import React, { useState, useMemo } from 'react';
import classnames from 'classnames';
import { find } from 'lodash';
import CheckBox from "../../common/details/CheckBox";
import Wysiwyg from '../../../../common/components/wysiwyg';
import { classNameError, errorsText } from '../../brand_snapshot/common/helpers';
import { sendMessage } from './controllerMessaging';

const App = ({ data, errors, metricName }) => {
  const metric = useMemo(() => (
    find(data.express_metrics, (el) => (el.default_metric?.name === metricName))
  ), [ data, metricName ]);

  const fieldEnable = useMemo(
    () => `${metricName}_enable_custom_text`, [ metricName ]
  );
  const fieldText = useMemo(
    () => `${metricName}_custom_text`, [ metricName ]
  );

  const [ model, setModel ] = useState(() => ({
    [fieldEnable]: metric[fieldEnable],
    [fieldText]: metric[fieldText]
  }));

  const handleToggleCustomText = (newValue) => {
    setModel({ ...model, [fieldEnable]: newValue });
    sendMessage(metricName, fieldEnable, newValue);
  };

  const handleChangeCustomText = (newValue) => {
    setModel({ ...model, [fieldText]: newValue });
    sendMessage(metricName, fieldText, newValue);
  };

  return (
    <>
      <CheckBox
        className={ `checkbox-${metricName}` }
        initValue={ model[fieldEnable] }
        onChange={ handleToggleCustomText }
        inputId={ `id-custom-text-${metricName}` }
        text="Enable Custom Text"
        infoText={
          <>
            If custom text is enabled, entered text will be displayed on respondent side
            { ' ' }
            instead of default one.
          </>
        }
      />
      {
        model[fieldEnable] &&
        <div className={ classnames("form-group qualified_text-editor", `wysiwyg-${metricName}`, classNameError(errors, fieldText)) }>
          <Wysiwyg
            customPicker
            toolbarClassName="wysiwyg-menu"
            editorClassName="wysiwyg-textarea"
            placeholder="Add"
            enableIndent
            enableAlign
            value={ model[fieldText] }
            onChange={ handleChangeCustomText }
          />
          <div className="form-error">{ errorsText(errors, fieldText) }</div>
        </div>
      }
    </>
  );
};

export default App;
